import { Link } from "react-router-dom";
import { menus } from "../utils";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

const Sidebar = ({ handleClose }: { handleClose?: () => void }) => {
  const isMobile = useIsMobile();

  return (
    <>
      {menus?.map((menu: any) => {
        const isActive =
          location.pathname === menu.to ||
          location.pathname.startsWith(menu.to + "/");

        if (menu.children && menu.children.length > 0) {
          return (
            <>
              <Link
                to={menu.to || ""}
                key={menu.title}
                onClick={handleClose}
                className={cn(
                  "flex relative group transition-all text-[14px] font-[500]",
                  isActive
                    ? "text-primary"
                    : "text-gray-500 hover:text-primary",
                  isMobile
                    ? "w-full p-[5px] mb-[10px] flex-row items-start gap-2"
                    : "px-[10px] py-[10px] mb-[5px] flex-row items-center justify-center"
                )}
              >
                {/* Active Indicator */}
                {!isMobile && (
                  <div
                    className={cn(
                      "w-1 h-full bg-primary absolute rounded-full left-0 transition-opacity",
                      isActive
                        ? "opacity-100"
                        : "opacity-0 group-hover:opacity-100"
                    )}
                  ></div>
                )}
                <menu.icon
                  className={cn(
                    "xl:h-auto xl:w-auto",
                    isActive
                      ? "stroke-primary text-primary"
                      : "stroke-black text-black group-hover:text-primary group-hover:stroke-primary opacity-[67%] group-hover:opacity-100"
                  )}
                />
                <span
                  className={
                    isActive
                      ? "text-primary"
                      : "group-hover:text-primary text-black opacity-[67%] group-hover:opacity-100"
                  }
                >
                  {menu.title}
                </span>
              </Link>
              <div
                className={cn(
                  "absolute top-0 bg-white h-full px-[15px] py-[20px] w-[200px] rounded-r-lg transition-all duration-300 ease-in-out",
                  isActive
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 -translate-x-5 pointer-events-none",
                  isMobile ? "left-[180px]" : "left-[117px]"
                )}
              >
                <div className="flex flex-row gap-2">
                  {menu.children.map((child: any) => {
                    const isChildActive =
                      location.pathname === child.to ||
                      location.pathname.startsWith(child.to + "/");
                    return (
                      <Link
                        to={child.to}
                        key={child.title}
                        onClick={handleClose}
                        className={cn(
                          "text-[14px] font-[500] px-2 py-1 rounded-md",
                          isChildActive
                            ? "bg-primary text-white"
                            : "text-black hover:text-white hover:bg-primary opacity-[67%]"
                        )}
                      >
                        {child.title}
                      </Link>
                    );
                  })}
                </div>
              </div>
            </>
          );
        } else if (menu.to) {
          return (
            <Link
              to={menu.to}
              key={menu.title}
              onClick={handleClose}
              className={cn(
                "flex relative  group transition-all text-[14px] font-[500]",
                isActive ? "text-primary" : "text-gray-500 hover:text-primary",
                isMobile
                  ? "w-full p-[5px] mb-[10px] flex-row items-start gap-2"
                  : "px-[10px] py-[10px] mb-[5px] flex-row items-center justify-start max-w-[238px]"
              )}
            >
              <menu.icon
                className={cn(
                  "xl:h-auto xl:w-auto mr-3",
                  isActive
                    ? "stroke-primary text-primary"
                    : "stroke-black text-black group-hover:text-primary group-hover:stroke-primary opacity-[67%] group-hover:opacity-100"
                )}
              />
              <span
                className={
                  isActive
                    ? "text-primary text-center"
                    : "group-hover:text-primary text-black text-center opacity-[67%] group-hover:opacity-100"
                }
              >
                {menu.title}
              </span>
            </Link>
          );
        }
      })}
    </>
  );
};

export default Sidebar;
